<template>
    <WorkshopList
        title="Workshopy"
        description="Prihláste sa na niektorý z pripravovaných workshopov, alebo využite možnosť vytvorenia workshopu na mieru."
        postsTag="WORKSHOP"
        routeName="workshops">
         <template v-slot:content>
            <PostPreview
                :id="'request_workshop'"
                :title="'Nevyhovuje Vám pripravovaný workshop?'"
                :attachments="[]"
                :imagePreview="'/css/images/homepage/actual_plans.png'"
                :to="localeRoute({name: 'workshops_request_workshop'})"
                maskClassName='mm-mask-colored mm-mask--right'
            />
        </template>
    </WorkshopList>
</template>

<script>
import WorkshopList from '@/components/workshop/WorkshopList';
import PostPreview from '@/components/PostPreview';

export default {
    components: {
        WorkshopList,
        PostPreview
    }
}
</script>
